import Layout from '@/components/feature/Layout';
import { contactInfo } from '@/mocks/codesajan';

export default function ContactPage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=simple%20community%20water%20committee%20office%20building%20in%20rural%20bolivia%2C%20clean%20modest%20exterior%20with%20small%20signage%2C%20bright%20daylight%2C%20warm%20natural%20lighting%2C%20editorial%20documentary%20photography%2C%20clean%20composition%20with%20space%20for%20text%20overlay&width=1800&height=600&seq=contact-hero-office&orientation=landscape"
            alt="Oficinas de CODESAJAN en San Jacinto Norte"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Contacto
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Contactanos
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Estamos aquí para atenderte. Escribinos por WhatsApp o visitanos en nuestras oficinas.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            {/* Contact info */}
            <div className="space-y-6">
              <div>
                <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">
                  Información de Contacto
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                      <i className="ri-map-pin-line text-primary-600 w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950">Dirección</p>
                      <p className="text-sm text-foreground-600">{contactInfo.address}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                      <i className="ri-time-line text-primary-600 w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950">Horario de Atención</p>
                      <p className="text-sm text-foreground-600">{contactInfo.hours}</p>
                      <p className="text-sm text-foreground-600">{contactInfo.weekend}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contacto rápido */}
              <div>
                <p className="text-sm font-medium text-foreground-950 mb-3">Contacto Rápido</p>
                <a
                  href={contactInfo.social.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors text-sm"
                >
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                  Escribir por WhatsApp
                </a>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div>
              <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 rounded-2xl bg-green-50 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-whatsapp-line text-green-500 text-2xl w-7 h-7 flex items-center justify-center"></i>
                </div>
                <h2 className="font-heading font-semibold text-lg text-foreground-950 mb-3">
                  Escribinos por WhatsApp
                </h2>
                <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
                  Atendemos tus consultas, reclamos y sugerencias por WhatsApp. Respondemos a la brevedad durante nuestro horario de atención.
                </p>
                <a
                  href="https://wa.me/59173455233?text=Hola%20CODESAJAN,%20quisiera%20hacer%20una%20consulta"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-xl transition-all duration-300 hover:-translate-y-0.5 text-sm"
                >
                  <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
                  Iniciar Conversación
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}